import { SiteModel } from "@/models/site.model";
import {
  createJsonFromAbaca,
  ErrorImportType,
  importAbacaFromJson,
  saveFile,
} from "@/services/export.service";
import store from "@/store";
import { Component, Prop, Vue } from "vue-property-decorator";
import { VueScreenObject } from "vue-screen";

import ImportReportError from "@/components/ImportReportError/index.vue";
import ConfirmModal from "@/components/ConfirmModal/index.vue";
import moment from "moment";
import { RESET_STORE } from "@/store/operators";
@Component({
  components: {
    ImportReportError,
    ConfirmModal,
  },
})
export default class AppMenuComponent extends Vue {
  $screen!: VueScreenObject;
  errorType: ErrorImportType = ErrorImportType.PARSE_ERROR;
  //The extension come from i18n. When the string is changed it will break compatibility with older save files
  abacaExtension = this.$t("configurations.abacaExtension").toString();
  @Prop({ default: false }) visible!: boolean;

  get dataVersion(): string {
    return store.state.globalAppDataModule.dataTypeVersion;
  }

  // import abaca or excel file and store it into abaca app
  importResult(event: Event): void {
    const target = event.target as HTMLInputElement;
    const files = target.files as FileList;
    const reader = new FileReader();

    if (files.length > 0) {
      const extension = this.getExtension(files[0].name);
      if (extension != this.abacaExtension) {
        this.handleImportError(ErrorImportType.PARSE_ERROR);
        return;
      }
      reader.onload = (e) => {
        const result = e.target?.result;
        if (typeof result == "string") {
          try {
            const json = JSON.parse(result);
            if (json.dataTypeVersion != this.dataVersion) {
              this.handleImportError(ErrorImportType.VERSION_ERROR);
            } else {
              importAbacaFromJson(json);
            }
          } catch (exception) {
            this.handleImportError(ErrorImportType.PARSE_ERROR);
          }
        }
      };
      reader.readAsText(files[0], "UTF-8");
    }
    this.closeMenu();
  }

  //handle abaca errors
  handleImportError(error: ErrorImportType): void {
    this.errorType = error;
    this.$bvModal.show("showImportError");
  }

  // get extension of an imported file
  getExtension(fileName: string): string {
    const extension = fileName.split(".").pop();
    return extension ? extension : "";
  }

  // export actual state of app and store it into a json to export
  saveResult(): void {
    const abacaJson = createJsonFromAbaca();
    const site: SiteModel = { ...store.state.siteModule.site };
    const name = this.$t("configurations.export", {
      fileName: site.title,
      date: moment().format("YYYY-MM-DD"),
      time: moment().format("HH[h]mm"),
    })
      .toString()
      .replaceAll(" ", "_");
    saveFile(name, abacaJson, this.abacaExtension);
    this.closeMenu();
  }

  fileUpload(): void {
    const file = document.getElementById("fileUpload");
    file?.click();
  }

  //Clean store
  resetStore(): void {
    this.closeConfirmModal();
    store.dispatch(RESET_STORE);
    this.closeMenu();
  }

  onImportErrorModalClose(): void {
    this.$bvModal.hide("showImportError");
  }

  /*
  Show Confirm Modal
  */
  showConfirmModal(): void {
    this.$bvModal.show("confirmClean");
  }

  /*
  Hide Confirm Modal
  */
  closeConfirmModal(): void {
    this.$bvModal.hide("confirmClean");
  }

  get isPhone(): boolean {
    return !this.$screen.lg;
  }

  /*
  Event to close the menu and delete the shadow over the app
  */
  closeMenu(): void {
    this.$emit("closeMenu");
  }
}
